<template>
    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
        <form @submit.prevent="submit" id="settings_form">
            <div class="d-flex align-items-center justify-content-between px-3">
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 0 24 24"
                        width="24px"
                        fill="#00bea5"
                    >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                        />
                    </svg>
                    <span class="pr-2">اعلانات تلگرامی</span>
                </div>
                <div>
                  <a class="telegram-icon" target="_blank" href="https://t.me/Paystar_bot">Paystar_bot@</a>
                </div>
                <div>
                    <button
                        type="submit"
                        class="btn btn-success px-4"
                        style="border-radius: 10px"
                        id="submit_btn"
                        :disabled="form_submit_loading"
                    >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                  class="spinner-border spinner-border-sm p-2"
                  role="status"
              ></span>
            </span>
                        <span v-else>ثبت تغییرات</span>
                    </button>
                </div>
            </div>
            <hr />

            <div class="alert alert-success m-3" style="border-radius: 10px">
        <span
        >پیام های اطلاع رسانی را که تمایل به دریافت آنها دارید، انتخاب
          کنید.</span
        >
            </div>

            <div class="p-3">
                <div class="form-group form-check">
                    <label class="switch">
                        <input
                            type="checkbox"
                            id="change_password"
                            v-model="telegramData.send_change_password"
                        />
                        <span class="slider round"></span>
                    </label>
                    <label
                        for="change_password"
                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >تغییر کلمه عبور</label
                    >
                </div>
                <div class="form-group form-check">
                    <label class="switch">
                        <input
                            type="checkbox"
                            id="ticket_reply"
                            v-model="telegramData.send_ticket_reply"
                        />
                        <span class="slider round"></span>
                    </label>
                    <label
                        for="ticket_reply"
                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >پاسخ به تیکت</label
                    >
                </div>
                <div class="form-group form-check">
                    <label class="switch">
                        <input
                            type="checkbox"
                            id="gateway_status_change"
                            v-model="telegramData.send_terminal_change_status"
                        />
                        <span class="slider round"></span>
                    </label>
                    <label
                        for="gateway_status_change"
                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >تغییر وضعیت درگاه</label
                    >
                </div>
                <div class="form-group form-check">
                    <label class="switch">
                        <input
                            type="checkbox"
                            id="successful_transaction"
                            v-model="telegramData.send_successful_transaction"
                        />
                        <span class="slider round"></span>
                    </label>
                    <label
                        for="successful_transaction"
                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >تراکنش موفق</label
                    >
                </div>
                <div class="form-group form-check">
                    <label class="switch">
                        <input
                            type="checkbox"
                            id="settlement"
                            v-model="telegramData.send_settlement"
                        />
                        <span class="slider round"></span>
                    </label>
                    <label
                        for="settlement"
                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >تسویه حساب درگاه</label
                    >
                </div>
                <div class="form-group form-check">
                    <label class="switch">
                        <input
                            type="checkbox"
                            id="send_login_system_success"
                            v-model="telegramData.send_login_system_success"
                        />
                        <span class="slider round"></span>
                    </label>
                    <label
                        for="send_login_system_success"
                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >ورود به پنل کاربری</label
                    >
                </div>
                <!-- <div class="form-group form-check">
                    <label class="switch">
                        <input
                            type="checkbox"
                            id="send_wallet_settlement_success"
                            v-model="telegramData.send_wallet_settlement_success"
                        />
                        <span class="slider round"></span>
                    </label>
                    <label
                        for="send_wallet_settlement_success"
                        class="btn m-0 p-0 text-secondary form-check-label pr-4"
                    >تسویه کیف پول</label
                    >
                </div> -->
            </div>
        </form>
    </div>

</template>

<script>
import {mapGetters} from "vuex";
import $ from "jquery";
import { notificationService } from "@/common/api.service";


export default {
    name: "telegram",
    data() {
        return {
            form_submit_loading: false
        }
    },
    computed: {
        ...mapGetters("notification", ["telegramData"]),
    },

    methods: {
        submit(e) {
            let form = $("#settings_form");
            let btn = $("#submit_btn");

            this.form_submit_loading = true;

            let params = this.telegramData

            notificationService
                .updateTelegram(params)
                .then((response) => {
                    this.showMsg(form, "success", response.data.message);
                })
                .catch(({ response }) => {
                    this.showMsg(form, "danger", response.data.message);
                })
                .finally(() => {
                    this.form_submit_loading = false;
                });
        },
    },
}
</script>

<style scoped>
  .telegram-icon {
    background-color: #31A6D8;
    padding: 5px 8px;
    border-radius: 5%;
    font-weight: normal;
    color: whitesmoke;
  }

  .telegram-icon:hover {
    background-color: #7ec1e0;
    font-weight: lighter;
    transition-duration: 0.3s;
    color: black;
  }
</style>